import axios from 'axios';
import {getBuildNumber,getVersion} from 'react-native-device-info';
import { isNetworkAvailable } from '../../hooks/useConnection';
import { useAppPersistenceStore } from '../../store/useAppPersistenceStore';
import { useProfileStore } from '../../store/useProfileStore';
import { adaptiveStreamURI, getFeedURI } from '../paths';
import { Platform } from 'react-native';
import { webBuildNumber } from '@ninjacart/nc-nk-core';
import { handleRetry } from '../../utils/handleRetry';

export const axiosAdaptiveHubClient = axios.create({
  baseURL: adaptiveStreamURI(),
  timeout: 60000,
  headers: {
    Accept: 'application/json',
    'x-build-number': Platform.OS === 'web' ? webBuildNumber : Number(getBuildNumber()),
    'x-platform': Platform.OS,
    'x-version-code': getVersion(),
    Authorization: useProfileStore.getState().userProfile?.access_token
      ? `Bearer ${useProfileStore.getState().userProfile?.access_token}`
      : '',
    'x-peertube-auth': `Bearer ${useProfileStore.getState().streamConfig?.access_token}`,
    'x-language-code': useAppPersistenceStore?.getState()?.appLanguage,
    ...(Platform.OS !== 'web' && { 'Accept-Encoding': 'gzip' }),
  },
});

axiosAdaptiveHubClient.interceptors.request.use(async (config) => {
  const isConnected = isNetworkAvailable();
  if (!isConnected) {
    console.log('Network in not connected!!!');
    return Promise.reject('No internet available!!!');
  }

  config.headers.Authorization = useProfileStore.getState().userProfile?.access_token
    ? `Bearer ${useProfileStore.getState().userProfile?.access_token}`
    : '';
  config.headers['x-peertube-auth'] =
    `Bearer ${useProfileStore.getState().streamConfig?.access_token}`;
  config.headers['x-language-code'] = useAppPersistenceStore?.getState()?.appLanguage;
  return Promise.resolve(config);
});

axiosAdaptiveHubClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const config = error.config;
    if (error.response?.status === 401) {
      return Promise.reject(config);
    }
    return handleRetry(error, config, 'AXIOS_ADAPTIVE_HUB_FAILED', axiosAdaptiveHubClient);
  }
);
